import { QuestionAnswerType, StructuredAnswer } from '@dreryk/egabinet-survey-frontend-api';

import { MedicalProfileAnswerValue } from './MedicalProfileTab.types';

const isEmptyValue = (value: MedicalProfileAnswerValue | undefined): boolean =>
   value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);

export const answerToFormValue = (
   answerType: QuestionAnswerType,
   answer: StructuredAnswer | undefined
): MedicalProfileAnswerValue => {
   if (!answer) {
      return null;
   }
   switch (answerType) {
      case 'SINGLE_CHOICE':
         return answer.selections?.[0]?.code ?? null;
      case 'MULTI_CHOICE':
         return (answer.selections ?? []).map((selection) => selection.code);
      case 'TEXT':
         return answer.text ?? null;
      case 'NUMBER':
         return answer.numberFrom ?? null;
      case 'DATE':
      case 'DATE_RANGE':
      case 'CODED':
      case 'MULTI_CODED':
         return null;
      default:
         return null;
   }
};

export const formValueToAnswer = (
   questionId: number,
   answerType: QuestionAnswerType,
   value: MedicalProfileAnswerValue | undefined
): StructuredAnswer | null => {
   if (isEmptyValue(value)) {
      return null;
   }
   switch (answerType) {
      case 'SINGLE_CHOICE':
         return { questionId: questionId, selections: [{ code: value as string }] };
      case 'MULTI_CHOICE':
         return { questionId: questionId, selections: (value as string[]).map((code) => ({ code: code })) };
      case 'TEXT':
         return { questionId: questionId, selections: [], text: value as string };
      case 'NUMBER':
         return { questionId: questionId, selections: [], numberFrom: value as number };
      case 'DATE':
      case 'DATE_RANGE':
      case 'CODED':
      case 'MULTI_CODED':
         return null;
      default:
         return null;
   }
};

const areArraysEqual = (first: string[], second: string[]): boolean =>
   first.length === second.length && first.every((item) => second.includes(item));

export const areFormValuesEqual = (
   first: MedicalProfileAnswerValue | undefined,
   second: MedicalProfileAnswerValue | undefined
): boolean => {
   if (isEmptyValue(first) && isEmptyValue(second)) {
      return true;
   }
   if (Array.isArray(first) && Array.isArray(second)) {
      return areArraysEqual(first, second);
   }
   return first === second;
};
